<template>
  <div class="">
    <div class="mb-3"><input type="checkbox" v-model="questions[index].isBookmarkArr[0]" @click="bookmark(0)" class="G6zckbvr " :class="{'eJ7LMsiQ': questions[index].isBookmarkArr[0]}">問{{question.no}}</div>
    <!-- <p :class="'qi-' + question.id" v-html="question.question1"></p> -->
    <p :class="'qi-' + question.id" v-html="question.question2"></p>
    <ol class="Ar2jysLK" :class="{'Gm8W5aZb': questions[index].isBookmarkArr[0]}">
      <li v-for="n in 4" :key="n">
        <div v-if="question['choice' + String(n)] && question['choice' + String(n)] != ''">
          <label class="d-flex align-items-start">
            <input class="" type="radio" name="select" @change="answer(n)" :checked="question['currentChoice'] == n">
            <div v-if="question['choice1'] != '〇'" class="s4NVRcXx">{{ n }}.</div>
            <div v-else class="nimnim"></div>
            <div class="Ki9LFtxd" v-html="question['choice' + String(n)]"></div>
          </label>
        </div>
      </li>
    </ol>
    <div style="height: 250px;"></div>
  </div>
</template>


<script lang="ts">
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Question from "../../models/question";
import StorageService from "../../services/storage";
import question from "@/services/question";
@Component({
  components: {}
})
export default class Choice extends Vue {
  @Prop()
  private question!: Question;
  @Prop()
  private index!: number;
  @Prop()
  private indexs!: number[];
  @Prop()
  public questions!: Question[]

  private isLock: boolean = false;
  created() {
    if (this.questions[this.index].isBookmarkArr == undefined) this.questions[this.index].isBookmarkArr = [false, false, false, false]
  }
  mounted() {}


  @Emit("answerEmit")
  answerEmit () {
    return
  }

  private bookmark(index: number) {
    if (this.questions[this.index].isBookmarkArr == undefined) this.questions[this.index].isBookmarkArr = [false, false, false, false]
    if (this.questions[this.index].isBookmarkArr[index] == undefined) this.questions[this.index].isBookmarkArr[index] = false
    this.questions[this.index].isBookmarkArr[index] = !this.questions[this.index].isBookmarkArr[index];

    this.$store.commit("setQuestions", this.questions);
    this.answerEmit();
  }

  public async answer(i: number) {
    this.questions[this.index].result = this.question.answer == String(i);
    this.questions[this.index].currentChoice = i;
    this.$store.commit("setQuestions", this.questions);
    this.answerEmit();
  }
}
</script>
